module.exports = __webpack_public_path__ + "static/media/error.db6c7321.jpeg";